import React, { useEffect, useState } from "react";
import DataTable from '../../components/DataTable'
import { activitiesTableConfig } from "../../datatable.config";
import { Box, Button, Chip, CircularProgress, Grid, Hidden, Input, LinearProgress, MenuItem, Paper, Select, Stack, TablePagination, TextField, Typography, useTheme } from "@mui/material";
import CardComponent from "../../components/Card";
import { useTranslation } from "react-i18next";
import { epochToDatetimeStrWithTz, mappingValue } from "../../utils/util";
import LinearBuffer from "./LinearBuffer"
import { Field, Form } from "react-final-form";
import { AutocompleteCustom, DateTimeTextFieldCustom, SelectCustom, TextFieldCustom } from "../../components/FormElements";

export default function TotalActivitiesView(props) {
    console.log("AAAA TotalActivitiesView props: ", props)
    const { activities, paging, dataSearch, isSearching, setIsSearching, types, onSearch, pageTotal, setPageTotal } = props
    const { t } = useTranslation();

    const [rowsPerPageTotal, setRowsPerPageTotal] = useState(10);
    const [paginatedRows, setPaginatedRows] = useState([]);
    const handleChangePageTotal = (event, newPage) => {
        setPageTotal(newPage);
    };

    useEffect(() => {
        if (isSearching) {
            setPaginatedRows(
                dataSearch.slice(pageTotal * rowsPerPageTotal, pageTotal * rowsPerPageTotal + rowsPerPageTotal)
            );
        } else {
            if (activities) {
                setPaginatedRows(
                    activities.slice(pageTotal * rowsPerPageTotal, pageTotal * rowsPerPageTotal + rowsPerPageTotal)
                );
            }
        }
    }, [pageTotal, rowsPerPageTotal, activities, isSearching, dataSearch]);
    const handleChangeRowsPerPageTotal = (event) => {
        setRowsPerPageTotal(parseInt(event.target.value, 10));
        setPageTotal(0);
    };
    return (
        <CardComponent noBorder marginTop={5}
            header={{
                title: t('total_activities'),
            }}>
            {props.showExecutionProcess && <Grid container justifyContent="flex-end">
                <Grid item component={Paper}>
                    <LinearBuffer status={props.actionState} />
                </Grid>
            </Grid>}
            <FormSearch
                isSearching={isSearching}
                setIsSearching={setIsSearching}
                types={types}
                typesSelected={props.typesSelected}
                setTypesSelected={props.setTypesSelected}
                statuses={props.statuses}
                onSubmit={onSearch}
                cities={props.cities}
                citySelected={props.citySelected}
                setCitySelected={props.setCitySelected}
                setPageTotal={setPageTotal}
            />
            {props.showLoading ? <Stack flex={1} alignItems={'center'}><CircularProgress /></Stack> :
                <>
                    <Hidden mdDown>
                        <DataTable
                            data={paginatedRows} tableConfig={activitiesTableConfig} onShowDetail={props.onShowDetail}
                        ></DataTable>
                    </Hidden>
                    <Hidden mdUp>
                        {isSearching ? <>
                            {paginatedRows.length == 0 ? <Typography variant='subtitle2'>No Record Found.</Typography> :
                                paginatedRows.map((item, index) => {
                                    return (
                                        <Box key={index} mb={1} onClick={() => props.onShowDetail(item)}>
                                            <ActivityItem item={item} />
                                        </Box>
                                    )
                                })
                            }
                        </> : <>
                            {paginatedRows.length == 0 ? <Typography variant='subtitle2'>No Record Found.</Typography> :
                                paginatedRows.map((item, index) => {
                                    return (
                                        <Box key={index} mb={1} onClick={() => props.onShowDetail(item)}>
                                            <ActivityItem item={item} />
                                        </Box>
                                    )
                                })
                            }
                        </>}
                    </Hidden>
                    {isSearching ? <> {dataSearch.length > 0 && <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 100]}
                        component="div"
                        count={dataSearch.length}
                        onPageChange={handleChangePageTotal}
                        rowsPerPage={rowsPerPageTotal}
                        page={pageTotal}
                        onRowsPerPageChange={handleChangeRowsPerPageTotal}
                    />}</> : <>
                        {activities.length > 0 && !isSearching && <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 100]}
                            component="div"
                            count={activities.length}
                            onPageChange={handleChangePageTotal}
                            rowsPerPage={rowsPerPageTotal}
                            page={pageTotal}
                            onRowsPerPageChange={handleChangeRowsPerPageTotal}
                        />}
                    </>}
                </>}
        </CardComponent>
    )
}

function ActivityItem(props) {
    const { item } = props;
    const { palette } = useTheme();
    const { t } = useTranslation();

    let statusColor = palette.info;
    if (item.state == 'COMPLETED') statusColor = palette.success;
    else if (item.state == 'PENDING') statusColor = palette.warning;

    return (
        <CardComponent paddingY={1} paddingX={2}>
            <Stack direction={'row'} alignItems={'center'} spacing={1}>
                <Stack flex={1} direction={'row'} alignItems='center' spacing={1}>
                    <Typography variant='body1'>{item.name}</Typography>
                    <Chip sx={{ background: statusColor.light, color: statusColor.main }} variant='customOutlined' size='small' label={t(mappingValue(item.state))} />
                </Stack>
            </Stack>
            <Stack direction={'row'} alignItems='center' spacing={1} mt={1}>
                <Stack flex={1}>
                    <Typography variant='body2'>{item.contact && item.contact.name ? item.contact.name : null}</Typography>
                </Stack>
                <Stack flex={1} direction='row' justifyContent={'flex-end'}>
                    <Typography variant='subtitle2'>{epochToDatetimeStrWithTz(item.created_date, true)}</Typography>
                </Stack>
            </Stack>
        </CardComponent>
    )
}

function FormSearch(props) {
    const { types, typesSelected, setTypesSelected, statuses, citySelected, cities } = props;
    const { t } = useTranslation();
    const [status, setStatus] = useState(null);

    const onClear = (form) => {
        props.setPageTotal(0)
        setTypesSelected([]);
        setStatus(null);
        props.setCitySelected(null);
        form.reset();
        props.setIsSearching(false);
    }
    // console.log("AAAA FormSearch typesSelected: ", typesSelected)
    // console.log("AAAA FormSearch cities: ", cities)

    return (
        <>
            <Form
                onSubmit={props.onSubmit}
                render={({ handleSubmit, form }) => (
                    <Grid item xs={12}>
                        <Grid item xs={12} container spacing={1} my={1}>
                            <Grid item xs={12} sm={6}>
                                {/* <Field
                                    name="type"
                                    label={t('type')}
                                    component={SelectCustom}
                                    isEdit={true}
                                    keyName={'id'}
                                    keyLabel={'name'}
                                    selectData={types}
                                    valueSelect={type ? type : null}
                                    placeholder={" "}
                                    onSelectedChange={(e) => setType(e.target.value)}
                                /> */}
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" mb={1}>{t('type')}</Typography>
                                    <Select
                                        multiple
                                        value={typesSelected}
                                        name="type"
                                        onChange={(e) => setTypesSelected(e.target.value)}
                                    >
                                        {types.map((item, index) => {
                                            return (
                                                <MenuItem key={index} value={item.id}>
                                                    {item.name}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </Grid>
                                <Grid item xs={12} container spacing={1} my={1}>
                                    <Grid item xs={12} sm={6}>
                                        <Field
                                            name="scheduled_date_from"
                                            label={t('scheduled_date_from')}
                                            component={TextFieldCustom}
                                            type="date"
                                            isEdit={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Field
                                            name="scheduled_date_to"
                                            label={t('scheduled_date_to')}
                                            component={TextFieldCustom}
                                            type="date"
                                            isEdit={true}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {/* <Field
                                    name="status"
                                    isEdit={true}
                                    component={TextFieldCustom}
                                    label={t('status')}
                                /> */}
                                <Grid item xs={12}>
                                    <Field
                                        name="status"
                                        label={t('status')}
                                        component={SelectCustom}
                                        isEdit={true}
                                        keyName={'key'}
                                        keyLabel={'text'}
                                        selectData={statuses}
                                        placeholder={" "}
                                        valueSelect={status}
                                        onSelectedChange={(e) => setStatus(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} container spacing={1} my={1}>
                                    {/* <Field
                                        name="city"
                                        isEdit={true}
                                        component={TextFieldCustom}
                                        label={t('city')}
                                    /> */}
                                    <Field
                                        name="city"
                                        isEdit={true}
                                        component={AutocompleteCustom}
                                        label={t('city')}
                                        options={cities}
                                        valuez={citySelected}
                                        defaultValuez={citySelected}
                                        onCustomChange={(e, item) => props.setCitySelected(item)}
                                        keyName={'key'}
                                        keyLabel={'text'}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Stack direction={'row'} spacing={2} my={2} justifyContent={'flex-end'}>
                            <Button id="formSearch/btnSubmit" size='small' variant='contained' onClick={handleSubmit}>{t('search')}</Button>
                            <Button id="formSearch/btnClear" size='small' variant='outlined' onClick={() => onClear(form)}>{t('clear')}</Button>
                        </Stack>
                    </Grid>
                )}
            />
        </>
    )
}